export default __webpack_public_path__ + "static/media/image.dd002cce.svg";